import {
  ADD_LOCAL_CLIENT, API_LOAD_CLIENTS, API_REMOVE_CLIENT, REMOVE_LOCAL_CLIENT, API_CREATE_CLIENT,
  API_UPDATE_CLIENT
} from './clients.reducer';
import { isLocal } from '../localId/localId';

export const load = () => ({ resourceAction: API_LOAD_CLIENTS });
export const save = resource => ((isLocal(resource.id)) ? { resourceAction: API_CREATE_CLIENT, resource } : { resourceAction: API_UPDATE_CLIENT, resource });
export const add = () => ({ type: ADD_LOCAL_CLIENT });
export const remove = id => ((isLocal(id)) ? { type: REMOVE_LOCAL_CLIENT, id } : { resourceAction: API_REMOVE_CLIENT, id });



// WEBPACK FOOTER //
// ./src/reducers/clients/clients.actions.js